import styled from 'styled-components';

export const Root = styled('p')`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize(12)};
  line-height: ${({ theme }) => theme.fontSize(15.6)};
  gap: ${({ theme: { spacing } }) => spacing(1)};
`;
